export default __webpack_public_path__ + "static/media/nurseKelley.a42b951a.png";